import React, { useState, useEffect } from "react";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import {
  deleteDevice,
  getAllDevices,
  getAPIToken,
  setDeviceData,
} from "../../../redux/features/devices/devices";
import DeviceTokenPopup from "../../../components/MyDevices/DeviceToken";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import TitleSubtitlePair from "../../../components/_utils/TitleSubtitlePair";
import TopNavSmallButton from "../../../components/_utils/CommonButtons/TopNavSmallButton";
import SwitcherTabs from "../../../components/_utils/CommonButtons/SwitcherTabs";
import CommonDetailCard from "../../../components/_utils/CommonDetailCard";
import SmallPopup from "../../../components/_utils/CommonSmallPopup";
import SVGComponent from "../../../components/_utils/SVGComponent";
import CommonToast from "../../../components/_utils/CommonToast";
import ICONS from "../../../assets/Icons";
import Loader from "../../../components/Loader/Index";
import { toast } from "react-toastify";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";

const MyDeviceDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { deviceid } = useParams();

  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [wantDeleted, setWantDeleted] = useState(false);
  const [isTokenGenerated, setIsTokenGenerated] = useState(false);
  const [tokenGeneratedFlag, setTokenGeneratedFlag] = useState(false);

  const services = useSelector((state) => state.refreshToken.services);
  const devices = useSelector(
    (state) => state.devices.allDevicesData?.devices || [],
  );

  const devicesLoading = useSelector(
    (state) => state.devices.allDevicesDataLoading,
  );

  useEffect(() => {
    if (devices.length === GlobalConfiguration.lengthCheckZero && deviceid) {
      dispatch(
        getAllDevices({
          page_no: GlobalConfiguration.lengthCheckOne,
          page_size: PaginationConfiguration.paginationSmall,
        }),
      );
    }
  }, [devices.length, deviceid, dispatch]);

  useEffect(() => {
    const tokenGenerated = sessionStorage.getItem("tokenGenerated");

    if (tokenGenerated === "true") {
      setIsTokenGenerated(true);
    } else {
      setIsTokenGenerated(false);
    }
  }, [tokenGeneratedFlag]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (event.target.className === "device-content-page") {
        setIsPopupOpen(false);
      }
    };

    if (isPopupOpen) {
      document.addEventListener("click", handleOutsideClick);
    } else {
      document.removeEventListener("click", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [isPopupOpen]);

  async function getToken() {
    try {
      const response = await dispatch(getAPIToken(loggedInDevice?.id));
      setToken(response.payload.device_details.q2p_token);
      sessionStorage.setItem("tokenGenerated", "true");
      setTokenGeneratedFlag((prev) => !prev);
      setIsTokenGenerated(true);
    } catch (err) {
      console.error(err);
    }
  }

  const handleTokenClick = async () => {
    if (services && !services?.includes("GenerateAPIToken")) {
      navigate("/feature_not_assigned");
      return;
    }

    await getToken();
    setIsPopupOpen(true);
  };

  function formatDeviceModel(model = "") {
    if (!model) return "";
    model = model.toLowerCase();
    model = model.replace(/^sdk[_\-]?/, "");
    model = model.replace(
      /[_\-]?(x86_64|x86|arm64|arm|emulator|simulator)$/g,
      "",
    );
    model = model.replace(/[_\-]+/g, " ").trim();
    model = model
      .split(" ")
      .map((word) =>
        word.length > GlobalConfiguration.lengthCheckOne
          ? word.charAt(GlobalConfiguration.lengthCheckZero).toUpperCase() +
            word.slice(GlobalConfiguration.lengthCheckOne)
          : word.toUpperCase(),
      )
      .join(" ");
    return model;
  }
  const currDevice = devices.find((device) => device.id === deviceid);

  const loggedInDevice = devices.find(
    (device) => device.logged_in_flag === "Y",
  );

  const isCurrentDeviceId =
    !!currDevice && loggedInDevice?.id === currDevice.id;

  const {
    id,
    browser_name,
    logged_in_flag,
    os_version,
    platform,
    created_by_name,
    logged_in_time,
    last_used,
    is_unauthorized,
    is_primary,
    model,
  } = currDevice || {};
  const nothing = () => {};

  const handleDeleteDevice = async (id) => {
    try {
      toast.dismiss();
      CommonToast({
        text: "Deleting device",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        variant: "var(--processing)",
      });
      const response = await dispatch(deleteDevice(id));

      if (response.payload.status === true) {
        navigate("/settings/devices_view_all", {
          state: {
            isDeviceDeleted: true,
          },
        });
      } else {
        CommonToast({
          text: response.payload.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--processing)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    } catch (err) {
      console.error(err, "err");
      CommonToast({
        text: "Failed to delete!",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
        variant: "var(--error)",
      });
    }
  };

  const ArrowLeft =
    "https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg";

  const GenerateToken =
    "https://q2pay.in/new_assets/common/settings/generate_token.svg";
  const DeleteIcon =
    "https://q2pay.in/new_assets/common/detail_page/delete_with_white_circle.svg";
  return (
    <div
      style={{
        overflowY: isPopupOpen || wantDeleted ? "hidden" : "auto",
        height: "var(--full-height)",
      }}
    >
      {wantDeleted && services?.includes("DDevice") && (
        <div className="fixed z-z-index-max flex  items-center justify-center  top-left-base left-left-base w-width-full h-height-full bg-custom-backdrop bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle="Delete device"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="Are you sure you want to delete this device?"
            btnOneText="Cancel"
            btnOneHandleFunction={() => setWantDeleted(false)}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Delete"
            btnTwoHandleFunction={() => handleDeleteDevice(id)}
            btnTwoEnabledBgColor="var(--failed)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {isPopupOpen && (
        <DeviceTokenPopup
          className="bg-dark-opacity"
          token={token}
          onClose={setIsPopupOpen}
          isPopupOpen={isPopupOpen}
        />
      )}
      {devicesLoading || !currDevice || !devices ? (
        <div className="device-loader-container h-full m-auto justify-center items-center flex">
          <Loader />
        </div>
      ) : (
        <div className="device-content-page">
          <div className="Qsmd:h-navbar-breadcrumb-height bg-primary-nav"></div>
          <div className="lg:hidden fixed w-full top-top-base bg-primary-card flex items-center cursor-pointer z-z-index-header py-padding-md px-padding-sm">
            <div onClick={() => navigate(GlobalConfiguration.navigate_back)}>
              <SVGComponent
                url={ArrowLeft}
                color="var(--text-primary)"
                height="var(--icon-sm)"
                width="var(--icon-sm)"
              />
            </div>
            <h1 className="text-font-md font-normal text-text-primary ml-margin-sm">
              Device details
            </h1>
          </div>
          <div className="device-container relative top-[var(--navbar-height)] Qsmd:mt-margin-base Qsmd:static Qsmd:pt-padding-base">
            <div className="w-auto bg-primary-nav md:pt-padding-base">
              <div className="Qlg:w-max-content-width w-width-full mx-auto pt-padding-base sm:mt-margin-base">
                <div className="flex items-center Qsmd:border-b border-primary-bg mt-margin-base">
                  <div className="w-full flex flex-col Qsmd:flex-row">
                    <div className="custom-border-deviceDetail-container Qsmd:w-width-md border-b-border border-primary-bg flex flex-row justify-between Qsmd:border-none Qsmd:flex-col  items-center Qsmd:items-start Qsmd:pl-padding-sm ml-margin-md Qsmd:ml-margin-base Qsmd:!justify-center mr-margin-md Qsmd:mr-0">
                      {platform === "android" ? (
                        <>
                          <div className="">
                            <TitleSubtitlePair
                              title={formatDeviceModel(model)}
                              subtitle="Model"
                              variant="md"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <TitleSubtitlePair
                            title={browser_name}
                            subtitle="Browser name"
                            variant="md"
                          />
                        </>
                      )}
                      <div className="block Qsmd:hidden">
                        <div className="h-full p-padding-md bg-text-primary flex flex-col items-center justify-center text-center">
                          <img
                            className="w-icon-lg h-icon-lg"
                            src={
                              currDevice?.platform === "android"
                                ? ICONS.ANDROID
                                : currDevice?.platform === "apple"
                                  ? ICONS.APPLE
                                  : currDevice?.browser_name === "Google Chrome"
                                    ? ICONS.CHROME
                                    : currDevice?.browser_name ===
                                        "Mozilla Firefox"
                                      ? ICONS.FIREFOX
                                      : currDevice?.browser_name ===
                                          "Internet Explorer"
                                        ? ICONS.INTERNET_EXPLORER
                                        : currDevice?.browser_name ===
                                            "Apple Safari"
                                          ? ICONS.SAFARI
                                          : ICONS.DEFAULT
                            }
                            alt="generate token"
                          />
                        </div>
                      </div>
                    </div>

                    {platform === "android" ? (
                      <div className="brand_deviceDetail-container Qsmd:border-l border-primary-bg  mx-margin-md Qsmd:mx-margin-base">
                        <div className="Qsmd:pl-padding-md">
                          <TitleSubtitlePair
                            title={currDevice?.brand}
                            subtitle="Brand"
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="flex flex-col Qsmd:w-width-md py-padding-sm Qsmd:border-l border-primary-bg border-b Qsmd:border-b-border-base Qsmd:border-primary-bg  mx-margin-md">
                        <div className="Qsmd:pl-padding-md ">
                          <TitleSubtitlePair
                            title={os_version ? os_version : "Not Available"}
                            subtitle="Operating system"
                          />
                        </div>
                      </div>
                    )}
                    {platform === "android" && (
                      <div className="flex flex-row Qsmd:border-l-border Qsmd:border-b-border-base Qsmd:border-primary-bg  Qsmd:flex-col Qsmd:justify-center justify-start border-b border-primary-bg  mx-margin-md Qsmd:mx-margin-base Qsmd:w-width-md py-padding-sm Qsmd:py-padding-base">
                        <div className=" Qsmd:pl-padding-md">
                          <TitleSubtitlePair
                            title={currDevice?.manufacturer}
                            subtitle="Manufacturer"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="Qsmd:block hidden">
                    <div
                      className={`flex justify-center items-center p-padding-xs bg-text-primary w-topnav-small-btn-width ${!isCurrentDeviceId ? "h-[var(--topnav-small-btn-width)]" : ""}
                      }`}
                    >
                      <div
                        className={`flex  z-z-index-base relative w-full h-full px-padding-button-s py-padding-sm flex-col items-center rounded-border-radius-sm justify-center 
                             
                            `}
                      >
                        <div className="mb-margin-xs">
                          <SVGComponent
                            url={
                              currDevice?.platform === "android"
                                ? ICONS.ANDROID
                                : currDevice?.platform === "apple"
                                  ? ICONS.APPLE
                                  : currDevice?.browser_name === "Google Chrome"
                                    ? ICONS.CHROME
                                    : currDevice?.browser_name ===
                                        "Mozilla Firefox"
                                      ? ICONS.FIREFOX
                                      : currDevice?.browser_name ===
                                          "Internet Explorer"
                                        ? ICONS.INTERNET_EXPLORER
                                        : currDevice?.browser_name ===
                                            "Apple Safari"
                                          ? ICONS.SAFARI
                                          : ICONS.DEFAULT
                            }
                            height="var(--icon-lg)"
                            width="var(--icon-lg)"
                          />
                        </div>
                        <div className="flex justify-center items-center text-font-xxs font-normal w-full overflow-hidden">
                          <span className="block w-full text-center truncate whitespace-nowrap text-primary-bg">
                            {isCurrentDeviceId && (
                              <>
                                Current <br /> device
                              </>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex items-center Qsmd:border-b border-primary-bg">
                  <div className="w-full flex flex-col Qsmd:flex-row">
                    <div className="custom-border-deviceDetail-container Qsmd:w-width-md mx-margin-md Qsmd:mx-margin-base  border-b-border border-primary-bg flex flex-row justify-between Qsmd:border-none Qsmd:flex-col Qsmd:pl-padding-sm  py-padding-sm">
                      <TitleSubtitlePair
                        title={platform
                          ?.toLowerCase()
                          ?.split(" ")
                          ?.map(function (word) {
                            return (
                              word
                                .charAt(GlobalConfiguration.lengthCheckZero)
                                .toUpperCase() +
                              word.slice(GlobalConfiguration.lengthCheckOne)
                            );
                          })
                          ?.join(" ")}
                        subtitle="Platform"
                      />
                    </div>

                    {platform === "android" && (
                      <div className="brand_deviceDetail-container Qsmd:border-l border-primary-bg mx-margin-md Qsmd:mx-margin-base">
                        <div className="Qsmd:pl-padding-md ">
                          <TitleSubtitlePair
                            title={os_version ? os_version : "Not Available"}
                            subtitle="Operating system"
                          />
                        </div>
                      </div>
                    )}

                    <div className=" border-primary-bg border-b Qsmd:border-primary-bg Qsmd:border-l Qsmd:border-b-border-base  mx-margin-md Qsmd:mx-margin-base flex flex-row Qsmd:flex-col justify-between Qsmd:w-width-md py-padding-sm">
                      <div className=" Qsmd:pl-padding-md">
                        <TitleSubtitlePair
                          title={created_by_name}
                          subtitle="Logged in by"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="Qsmd:block hidden">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Generate <br /> token{" "}
                        </>
                      }
                      isDisabled={logged_in_flag === "N" || isTokenGenerated}
                      handleFunction={
                        logged_in_flag === "N" || isTokenGenerated
                          ? nothing
                          : handleTokenClick
                      }
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      icon={GenerateToken}
                      hoverOption="white"
                    />
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="w-full flex flex-col Qsmd:flex-row">
                    <div
                      className={`custom-border-deviceDetail-container mx-margin-md Qsmd:mx-margin-base border-b-border border-primary-bg flex flex-row justify-between Qsmd:border-none Qsmd:flex-col  ${platform != "android" ? "Qsmd:w-width-md Qsmd:mr-margin-base" : "Qsmd:mr-margin-xs Qsmd:w-width-sm-1-3"}  justify-center Qsmd:pl-padding-sm py-padding-sm `}
                    >
                      <TitleSubtitlePair
                        title={formatDateViewAll(logged_in_time, true, true)}
                        subtitle="Last logged in at"
                      />
                    </div>
                    <div className="py-padding-sm Qsmd:border-l border-primary-bg">
                      <div className=" pl-padding-md ">
                        <TitleSubtitlePair
                          title={formatDateViewAll(last_used, true, true)}
                          subtitle="Last used at"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="Qsmd:block hidden">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Delete
                          <br />
                          device
                        </>
                      }
                      isDisabled={isCurrentDeviceId}
                      handleFunction={() => {
                        if (!services?.includes("DDevice")) {
                          navigate("/feature_not_assigned");
                          return;
                        }

                        if (isCurrentDeviceId) {
                          CommonToast({
                            text: "Device currently in use cannot be deleted.",
                            variant: "var(--error)",
                            icon: ICONS?.ERROR_WHITE_CIRCLE,
                            btnProps: {
                              isDisabled: false,
                              enabledTextColor: "var(--text-primary)",
                              enabledBgColor: "var(--primary-bg)",
                            },
                          });
                          return;
                        }

                        setWantDeleted(true);
                      }}
                      hoverOption="white"
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      icon={DeleteIcon}
                    />{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="block Qsmd:hidden mt-margin-md">
              <p className="bg-primary-card text-sm py-padding-sm font-semibold text-text-primary pl-padding-md flex items-center">
                Quick Actions
              </p>
              <div className="w-full bg-primary-nav-act flex border-t border-primary-bg">
                <TopNavSmallButton
                  fullWidthRequired
                  btnText="Generate token"
                  isDisabled={logged_in_flag === "N" || isTokenGenerated}
                  handleFunction={
                    logged_in_flag === "N" || isTokenGenerated
                      ? nothing
                      : handleTokenClick
                  }
                  enabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--primary-nav)"
                  icon={GenerateToken}
                  hoverOption="white"
                />
                <div className="border-r border-primary-bg"></div>
                <TopNavSmallButton
                  btnText="Delete device"
                  isDisabled={isCurrentDeviceId == true}
                  handleFunction={() => {
                    if (!services?.includes("DDevice")) {
                      navigate("/feature_not_assigned");
                      return;
                    }

                    if (isCurrentDeviceId) {
                      CommonToast({
                        text: "Device currently in use cannot be deleted.",
                        variant: "var(--error)",
                        icon: ICONS?.ERROR_WHITE_CIRCLE,
                        btnProps: {
                          isDisabled: false,
                          enabledTextColor: "var(--text-primary)",
                          enabledBgColor: "var(--primary-bg)",
                        },
                      });
                      return;
                    }

                    setWantDeleted(true);
                  }}
                  hoverOption="white"
                  enabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--primary-nav)"
                  icon={DeleteIcon}
                  fullWidthRequired
                  disabledBgColor="var(--primary-nav)"
                />{" "}
              </div>
            </div>
            <div className="device-details-div-section w-screen flex justify-center pb-padding-md">
              <div className="device-details-section Qlg:px-padding-base md:px-padding-md px-padding-md mt-margin-md w-full">
                <SwitcherTabs
                  initialActiveTab="details"
                  tabs={[
                    {
                      label: "Details",
                      key: "details",
                    },
                  ]}
                />
                <div className="flex flex-col Qsmd:flex-row gap-gap-md mt-margin-md">
                  <CommonDetailCard
                    cardTitle="Login Details"
                    numCols={1}
                    variant="fourth"
                    isDisabled={false}
                    entries={[
                      {
                        heading: "Login status",
                        content:
                          logged_in_flag === "Y" ? "Logged in" : "Logged out",
                        type: "text",
                      },
                      {
                        heading: "Device priority",
                        content: is_primary ? "Primary" : "Secondary",
                        type: "text",
                      },
                      {
                        heading: "Device authorization",
                        content: is_unauthorized
                          ? "Unauthorized"
                          : "Authorized",
                        type: "text",
                      },
                    ]}
                  />

                  {platform === "android" && (
                    <CommonDetailCard
                      cardTitle="App Details"
                      numCols={GlobalConfiguration.lengthCheckOne}
                      variant="fourth"
                      icon={ICONS.ANDROID}
                      isDisabled={false}
                      entries={[
                        {
                          heading: "App version code",
                          content: currDevice?.app_version_code,
                          type: "text",
                        },
                        {
                          heading: "App version name",
                          content: currDevice?.app_version_name,
                          type: "text",
                        },
                        {
                          heading: "SDK version",
                          content: currDevice?.sdk_version,
                          type: "text",
                        },
                      ]}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyDeviceDetails;
